import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import { Box, Typography } from "@mui/material";
import { DrawToolbar } from "components/boundary";
import { ClipConfigProps, ClipStepsControlProps } from "../../clip-menu";
import { BoundaryToolProps } from "./define-boundary";

export const DrawComponent = (
  props: ClipConfigProps & ClipStepsControlProps & BoundaryToolProps
) => {
  return (
    <Box display="flex" flexDirection="column" gap={2} height="100%">
      <Typography variant="subtitle1" color="text.secondary">
        Use the drawing tools below to draw a boundary
      </Typography>
      <DrawToolbar
        draw={props.draw}
        currentMode={props.currentMode}
        onModeChange={props.setCurrentMode}
      />
    </Box>
  );
};
